/* eslint-disable */

import AppLayout from "components/layouts/app-layout/AppLayout";
import "./App.css";

function App() {
  return (
    <div className="App">
      <AppLayout />
    </div>
  );
}

export default App;
